module.exports = __webpack_public_path__ + "img/wo.80568237.svg";